import { useMemo } from 'react';
import { FieldConfig } from '../../../../../../components/CustomFormsComponents/CustomField';

const useReconfirmationExamDrawerFieldsConfig = ({
    translate,
    formData,
    handleBlurValidation
}: any) => {
    const fieldsConfig = useMemo<FieldConfig[]>(
        () => [
            {
                type: 'text',
                label: translate('reconfirmation.drawer.assignExam.inputs.examName') as string,
                name: 'examName',
                required: true,
                value: formData.examName,
                disabled: false,
                helperText: translate('reconfirmation.drawer.assignExam.inputs.examName') as string,
                onBlurValidation: handleBlurValidation,
                gridSpace: { xs: 12 },
                validations: [{ name: 'required' }]
            }
        ],

        [formData, translate, handleBlurValidation]
    );

    return { fieldsConfig };
};

export default useReconfirmationExamDrawerFieldsConfig;
